import axios from 'axios'
import { ADMIN_DOMAIN } from 'globalUtils/constants'

export default function masterApiCall(method, url, data = {}) {
  return axios({
    method,
    url,
    data,
    headers: process.env.NODE_ENV === 'development' ? {
      'x-db-id': ADMIN_DOMAIN,
    } : {},
  })
}



// WEBPACK FOOTER //
// ./client/masteradmin/utils/api.js